module.exports = __webpack_public_path__ + "img/queue.ce8f3e55.svg";